import React from "react";

const PlayButtonSvgIcon = ({ width = 20, height = 20, style }) => {
  return (
    <div style={{ display: "inline-block", ...style }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.78 13.663C7.996 13.877 8.26 13.956 8.54 13.956C8.903 13.956 9.292 13.825 9.632 13.684C10.432 13.352 14.165 11.299 14.165 9.857C14.165 8.437 10.512 6.423 9.578 6.037C9.2 5.88 8.316 5.516 7.781 6.05C7.628 6.203 7.166 6.669 7.153 9.835C7.14 13.022 7.623 13.505 7.781 13.663H7.78ZM8.817 12.4C8.597 11.366 8.6 8.436 8.82 7.339C9.818 7.684 12.096 9.186 12.607 9.859C12.094 10.557 9.787 12.09 8.817 12.4Z"
          fill="#687382"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10C0 17.383 2.617 20 10 20C17.383 20 20 17.383 20 10C20 2.617 17.383 0 10 0C2.617 0 0 2.617 0 10ZM1.5 10C1.5 3.486 3.486 1.5 10 1.5C16.514 1.5 18.5 3.486 18.5 10C18.5 16.514 16.514 18.5 10 18.5C3.486 18.5 1.5 16.514 1.5 10Z"
          fill="#687382"
        />
      </svg>
    </div>
  );
};

export default PlayButtonSvgIcon;
